export const environment = {
    production: true,
    googleMapsApiKey: 'AIzaSyCzW3bMI9ZAXmcEqYlCZLG4oqSnb9eZW94',
};
